import React from 'react';
import {Badge, Button, ButtonGroup, Col, Row} from "reactstrap";
import moment from 'moment';
import _ from 'lodash';
import {css} from "glamor";
import {Field, Form, Formik} from "formik";
import ImageUploadComponent from "../../../../components/ImageUploadComponent/ImageUploadComponent";
import Icon from "react-icons-kit";
import {ic_close as CloseIcon} from 'react-icons-kit/md/ic_close';
import CheckInput from "../../../../components/CheckInput";
import {ValidationSchemas} from "./Common";
import {Async as AsyncSelect, components} from "react-select";
import ThreeLineItemRender from "../../../../components/Elements/ThreeLineItemRender";
import Utils from "../../../../common/Utils";
import StandardValue from "../../../../common/StandardValue";
import {FarmersEndpoints, UsersEndpoints} from "../../../../common/ProxyEndpoints";
import FormInput from "../../../../components/FormInput";
import TTLProxy from "../../../../common/TTLAsyncProxy";
import HTML from "../../../../common/HtmlHelpers";
import MDSpinner from "react-md-spinner";

const cardStyle = css({
    background: '#fff',
    borderRadius: 2,
    boxShadow: '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)'
});

export const Styles = {

    emptyViewStyle: css({
        padding: '1rem',
        cursor: "pointer",
        width: "100%",
        backgroundColor: "#b9b9b9",
        borderStyle: 'solid',
        borderRadius: 4,
        borderSize: 2,
        borderColor: "#FFF",
        boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
        '&:hover': {
            boxShadow: '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)'
        }
    }),

    pictureViewStyle: css({
        width: "100%",
        backgroundColor: "#b9b9b9",
        borderStyle: 'solid',
        borderRadius: 4,
        borderSize: 2,
        borderColor: "#FFF",
        boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
        '&:hover': {
            boxShadow: '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)'
        }
    }),

    buttonStyle: css({
        borderRadius: 4,
        boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
        '&:hover': {
            borderRadius: 4,
            boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
        }
    }),


    headerCardStyle: css({
        boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
    }),

    tooltipClass: css({
        maxWidth: 280,
        width: 280
    }),

    cardStyle
};

export const StatusRenderer = ({ enabled , confirmMessage , onChange }) => {

    return <CheckInput checked={enabled}
                style={{ margin: 0, padding: 0 }}
                title={<span className="mr-2">{enabled ? 'Enabled' : 'Disabled'}: </span>}
                onChange={() => {

                    if(window.confirm(typeof confirmMessage === "function" ? confirmMessage(enabled) : confirmMessage)){
                        onChange(enabled);
                    }

                }}/>
};


export const BasePageTemplate = ({ title, onClose , children }) => {

    return <div className="container-fluid">

        <div className="content-frame" style={{ marginBottom: 4 }}>

            <div className={`p-5 ${cardStyle} mb-5`}>

                <div className="clearfix">

                    <div className="pull-left">
                        <h4>{title}</h4>
                    </div>

                    {onClose && <div className="pull-right">
                        <span style={{ cursor: "pointer" }} onClick={onClose}><Icon icon={CloseIcon}/></span>
                    </div>}

                </div>

                <hr/>

                {children}


            </div>

        </div>

    </div>


};

export const ImageDisplay = ({  src,
                                height = 220,
                                backgroundColor = "#b9b9b9" }) => {

    return src ? <div className={`${Styles.pictureViewStyle}`} style={{ height , backgroundColor }}>

        <img src={src}
             alt={'Document image'}
             className={`img-fluid`}
             style={{
                 cursor: 'pointer',
                 width: "100%",
                 height:"100%",
                 objectFit: "contain"
             }}/>

    </div>:

    <div className={`${Styles.emptyViewStyle}`} style={{ height , backgroundColor , position: 'relative' }}>

        <div style={{
            margin: 0,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            display: 'inline-block'
        }}>
            <i className="fa fa-camera fa-2x" style={{ color: "white "}}/>
        </div>

    </div>

};


export const ImageField = ({   name ,
                        height = 220,
                        enableChange = true,
                        backgroundColor = "#b9b9b9"
                    }) => {

    return <Field name={name}>
        {({ field, form: { setFieldValue } }) => {

            return <ImageUploadComponent name={null}
                                         size={84}
                                         disabled={false}
                                         enableChange={enableChange}
                                         components={{

                                             EmptyView: ({ props , onClick }) => {

                                                 return <div className={`${Styles.emptyViewStyle}`} style={{
                                                     height ,
                                                     backgroundColor,
                                                     position: 'relative'
                                                 }} onClick={onClick}>

                                                     <div style={{
                                                         margin: 0,
                                                         position: 'absolute',
                                                         top: '50%',
                                                         left: '50%',
                                                         transform: 'translate(-50%, -50%)',
                                                         display: 'inline-block'
                                                     }}>
                                                         <i className="fa fa-camera fa-2x" style={{ color: "white "}}/>
                                                     </div>

                                                 </div>
                                             },

                                             ImageView: ({ props , photo , onClick }) => {

                                                 return <div className={`${Styles.pictureViewStyle}`} style={{ height , backgroundColor }} onClick={onClick}>

                                                     <img src={photo.src}
                                                          alt={'Document image'}
                                                          onClick={onClick}
                                                          className={`img-fluid`}
                                                          style={{
                                                              cursor: 'pointer',
                                                              width: "100%",
                                                              height:"100%",
                                                              objectFit: "contain"
                                                          }}/>

                                                 </div>

                                             }

                                         }}
                                         onChange={file => {
                                             setFieldValue(name,file);
                                         }}/>

        }}
    </Field>

};



export const BankPaymentStatus = ({ payment }) => {

    const StatusMessage = {
        Idle: "Idle (Pending)",
        Expired: "Expired",
        Active: "Active",
        Utilized: "Fully Used",
        Disabled: "Disabled",
        PendingVerification: "Pending Verification"
    };

    let status;
    let color;
    if(payment.enabled){

        if(!payment.verification_complete){
            status = StatusMessage.PendingVerification;
            color = "secondary";
        }
        else if(payment.remaining_amount <= 0){
            status = StatusMessage.Utilized;
            color = "secondary";
        }
        else{

            if(_.isNil(payment.date_available) && !_.isNil(payment.expires_at) && (!moment().isSameOrBefore(payment.expires_at))){
                status = StatusMessage.Expired;
                color = "danger";
            }
            else if(!_.isNil(payment.date_available) && _.isNil(payment.expires_at) && (!moment().isSameOrAfter(payment.date_available))){
                status = StatusMessage.Idle;
                color = "secondary";
            }
            else if(!_.isNil(payment.date_available) && !_.isNil(payment.expires_at)){

                if(moment().isAfter(payment.expires_at)){
                    status = StatusMessage.Expired;
                    color = "danger";
                }

                if(moment().isBefore(payment.date_available)){
                    status = StatusMessage.Idle;
                    color = "secondary";
                }
                else{
                    status = StatusMessage.Active;
                    color = "success";
                }

            }
            else{
                status = StatusMessage.Active;
                color= "success";
            }

        }

    }
    else{
        color = "danger";
        status = StatusMessage.Disabled;
    }

    return <h6><Badge pill color={color}>{status || "Unknown"}</Badge></h6>;
};

export const CreateBeneficiaryView = ({  onSubmit , currency , totalAmount , remainingAmount , beneficiaries }) => {

    return <Formik validationSchema={ValidationSchemas.AddConsumers}
                   onSubmit={async ( values , { setSubmitting } ) => {

                       try{

                           if(values.mode === "multi" && values.allFarmers){

                               const response = await TTLProxy.getInstance().processRequest(FarmersEndpoints.getUrl(), {
                                   fields: ['id' , 'phone', 'email']
                               });

                               values.farmers = response.getPayload().filter(x => {

                                   return _.isNil(beneficiaries.find(t => {

                                       if(_.isNil(t.farmers))
                                           return t.farmer.instance.id === x.id;

                                       return t.farmers.find(f => f.id === x.id);

                                   }));
                               });

                           }

                           onSubmit(values);
                       }
                       catch (e) {
                           HTML.toastError( Utils.getResponseError(e) );
                       }
                       finally {
                           setSubmitting(false);
                       }
                   }}
                   initialValues={{
                       comments: "",
                       max_amount: 1,
                       reference_mode: "phone_number",
                       passport_id: "",
                       drivers_id: "",
                       voters_id: "",
                       national_id: "",
                       phone: "",
                       farmer: null,
                       farmers: [],
                       mode: "single",
                       allFarmers: false
                   }}>

        {({ isValid , setFieldValue , values , errors , isSubmitting  }) => {

            return <Form>

                {values.mode === "single" && <React.Fragment>
                    <b>Beneficiary Farmer</b>
                    <p>Select farmer you wish to benefit from this payment</p>
                </React.Fragment>}

                {values.mode === "multi" && <React.Fragment>
                    <b>Beneficiary Farmers</b>
                    <p>Select farmers to benefit from this payment</p>
                </React.Fragment>}

                <div className="clearfix">

                    <div className="pull-right">

                        <label><input type="checkbox" checked={values.mode === "multi"} onChange={evt => {
                            setFieldValue('mode',evt.target.checked ? 'multi' : 'single');
                        }}/> Multiple Beneficiary</label>

                        {values.mode === "multi" && <label className="ml-1">
                            <input type="checkbox" checked={values.allFarmers} onChange={evt => {
                                setFieldValue('allFarmers',evt.target.checked);
                            }}/> All farmers
                        </label>}

                    </div>

                </div>


                {values.mode === "single" && <AsyncSelect  name="farmer"
                              cacheOptions
                              defaultOptions
                              placeholder="Search farmer..."
                              value={values.farmer}
                              isOptionDisabled={option => {

                                  return !!beneficiaries.find(t => {

                                      if(_.isNil(t.farmers))
                                          return t.farmer.instance.id === option.instance.id;

                                      return t.farmers.find(f => f.id === option.instance.id);
                                  });

                              }}
                              onChange={value => {
                                  setFieldValue('farmer',value);
                              }}
                              components={{
                                  Option: ({ children , ...props }) => {

                                      const farmer = props.data.instance;
                                      return <components.Option {...props}>

                                          <ThreeLineItemRender media={farmer.media}
                                                               line1Value={farmer.name}
                                                               line2Prefix="Phone"
                                                               line2Value={farmer.phone}
                                                               line3Prefix="Email"
                                                               line3Value={<StandardValue value={farmer.email}/>}/>

                                      </components.Option>

                                  }
                              }}
                              loadOptions={async (value) => {

                                  try {

                                      const proxy = TTLProxy.getInstance();
                                      const res = await proxy.processRequest(FarmersEndpoints.getUrl(), {
                                          search: { keyword: value , method: 'inside', fields: [
                                                  'phone' ,
                                                  'name',
                                                  'email',
                                                  'user.username'
                                              ]},
                                          pagination: { page: 1 , perPage : 5 },
                                          include: [ 'media' , 'user' ]
                                      });

                                      return res.getPayload().map(t => ({ label: t.name, value: t.id  , instance: t }));
                                  }
                                  catch (e) {

                                      // failed to load query

                                  }

                              }}/>}

                {values.mode === "multi" && <AsyncSelect  name="farmers"
                                                          cacheOptions
                                                          defaultOptions
                                                          isDisabled={values.allFarmers}
                                                          placeholder="Select farmers..."
                                                          value={values.farmers}
                                                          isMulti
                                                          isOptionDisabled={option => {

                                                              return !!beneficiaries.find(t => {

                                                                  if(_.isNil(t.farmers))
                                                                      return t.farmer.instance.id === option.instance.id;

                                                                  return t.farmers.find(f => f.id === option.instance.id);
                                                              });

                                                          }}
                                                          onChange={value => {
                                                              setFieldValue('farmers',value);
                                                          }}
                                                          components={{
                                                              Option: ({ children , ...props }) => {

                                                                  const farmer = props.data.instance;
                                                                  return <components.Option {...props}>

                                                                      <ThreeLineItemRender media={farmer.media}
                                                                                           line1Value={farmer.name}
                                                                                           line2Prefix="Phone"
                                                                                           line2Value={farmer.phone}
                                                                                           line3Prefix="Email"
                                                                                           line3Value={<StandardValue value={farmer.email}/>}/>

                                                                  </components.Option>

                                                              }
                                                          }}
                                                          loadOptions={async (value) => {

                                                              try {

                                                                  const proxy = TTLProxy.getInstance();
                                                                  const res = await proxy.processRequest(FarmersEndpoints.getUrl(), {
                                                                      search: { keyword: value , method: 'inside', fields: [
                                                                              'phone' ,
                                                                              'name',
                                                                              'email',
                                                                              'user.username'
                                                                          ]},
                                                                      pagination: { page: 1 , perPage : 5 },
                                                                      include: [ 'media' , 'user' ]
                                                                  });

                                                                  return res.getPayload().map(t => ({ label: t.name, value: t.id  , instance: t }));
                                                              }
                                                              catch (e) {

                                                                  // failed to load query

                                                              }

                                                          }}/>}

                <div className="mt-2">

                    <FormInput name={"max_amount"}
                               icon="fa fa-money"
                               type={"number"}
                               title={`Amount (${currency})`}
                               min={0}
                               max={remainingAmount}
                               placeholder={"Total amount to be allocated"}/>

                </div>

                <hr/>

                {values.mode === "single" && <React.Fragment>

                    <FormInput name={"reference_mode"}
                               type={"select"}
                               title={<b><i className="fa fa-key"/> Identification Method</b>}
                               items={[
                                   { text: "Phone No." , value: "phone_number" },
                                   { text: "Passport No." , value: "passport" },
                                   { text: "National ID" , value: "national_id" },
                                   { text: "Driver's License" , value: "drivers_license" },
                                   { text: "Voter's ID" , value: "voters_id" }
                               ]}/>

                    <div className="p-3" style={{ backgroundColor: "#fafafa"}}>

                        {values.reference_mode === "phone_number" && <div>

                            <div className="p-2" style={{ backgroundColor: "#ececec" }}>
                                {values.farmer ? values.farmer.instance.phone : "None"}
                            </div>

                        </div>}

                        {values.reference_mode === "passport" && <div>

                            <FormInput name={"passport_id"}
                                       type={"text"}
                                       title={"Passport No."}
                                       placeholder={"Enter passport no."}/>

                        </div>}

                        {values.reference_mode === "national_id" && <div>

                            <FormInput name={"national_id"}
                                       type={"text"}
                                       title={"National ID"}
                                       placeholder={"Enter national id"}/>

                        </div>}

                        {values.reference_mode === "drivers_license" && <div>
                            <FormInput name={"drivers_license"}
                                       type={"text"}
                                       title={"Driver License No."}
                                       placeholder={"Enter driver's license no."}/>
                        </div>}


                        {values.reference_mode === "voters_id" && <div>
                            <FormInput name={"voters_id"}
                                       type={"text"}
                                       title={"Voter's ID"}
                                       placeholder={"Enter voter's id"}/>
                        </div>}

                    </div>

                    <hr/>

                </React.Fragment>}


                <h6><i className="fa fa-comment"/> Comments</h6>
                <textarea name={"comments"}
                          className="form-control form-input"
                          placeholder="Enter some remarks or comments here"
                          value={values.comments}
                          onChange={evt => {
                              setFieldValue('comments',evt.target.value)
                          }}
                          rows={4}/>

                <hr/>

                <Button color="green" block disabled={!isValid || isSubmitting}>
                    {!isSubmitting && <React.Fragment><i className="fa fa-plus"/> Add Beneficiary</React.Fragment>}
                    {isSubmitting && <MDSpinner singleColor="#FFF" size={24}/>}
                </Button>


            </Form>

        }}
    </Formik>;


};




// WEBPACK FOOTER //
// ./src/views/Extras/Finance/VirtualCredit/Elements.js